module.exports = __webpack_public_path__ + "img/cooperate_jr_02@2x.9eddd471.png";